(() => {
  function syncNavOffsets(section) {
    const wrap = section.querySelector('.sunster-rvac-installation__slider-wrap');
    const activeCard = section.querySelector(
      '.sunster-rvac-installation__slide.swiper-slide-active .sunster-rvac-installation__slide-card'
    );
    const prevEl = section.querySelector('.sunster-rvac-installation__nav--prev');
    const nextEl = section.querySelector('.sunster-rvac-installation__nav--next');

    if (!wrap || !activeCard || !prevEl || !nextEl) return;

    if (window.matchMedia('(max-width: 749px)').matches) {
      section.style.removeProperty('--sunster-rvac-installation-nav-offset-prev');
      section.style.removeProperty('--sunster-rvac-installation-nav-offset-next');
      return;
    }

    const wrapRect = wrap.getBoundingClientRect();
    const cardRect = activeCard.getBoundingClientRect();
    const edgeGap = 16;
    const prevMax = Math.max(edgeGap, wrapRect.width - prevEl.offsetWidth - edgeGap);
    const nextMax = Math.max(edgeGap, wrapRect.width - nextEl.offsetWidth - edgeGap);
    const prevOffset = Math.min(Math.max(cardRect.left - wrapRect.left + edgeGap, edgeGap), prevMax);
    const nextOffset = Math.min(Math.max(wrapRect.right - cardRect.right + edgeGap, edgeGap), nextMax);

    section.style.setProperty('--sunster-rvac-installation-nav-offset-prev', `${prevOffset}px`);
    section.style.setProperty('--sunster-rvac-installation-nav-offset-next', `${nextOffset}px`);
  }

  function scheduleNavSync(section) {
    if (section._installationNavFrame) {
      window.cancelAnimationFrame(section._installationNavFrame);
    }

    section._installationNavFrame = window.requestAnimationFrame(() => {
      section._installationNavFrame = null;
      syncNavOffsets(section);
    });
  }

  function recenterIfNeeded(swiper, realSlideCount) {
    if (!swiper || !realSlideCount) return;
    const activeIndex = swiper.activeIndex;

    if (activeIndex < realSlideCount) {
      swiper.slideTo(activeIndex + realSlideCount, 0, false);
    } else if (activeIndex >= realSlideCount * 2) {
      swiper.slideTo(activeIndex - realSlideCount, 0, false);
    }
  }

  function initInstallationSection(section) {
    if (!section || section.dataset.swiperReady === 'true') return;
    if (typeof Swiper === 'undefined') return;

    const container = section.querySelector('.sunster-rvac-installation__swiper');
    const nextEl = section.querySelector('.sunster-rvac-installation__nav--next');
    const prevEl = section.querySelector('.sunster-rvac-installation__nav--prev');
    const realSlideCount = Number(section.dataset.realSlides || 0);
    if (!container || !nextEl || !prevEl || !realSlideCount) return;

    const initialRealIndex = Math.min(1, Math.max(0, realSlideCount - 1));
    const initialSlide = realSlideCount + initialRealIndex;

    const swiper = new Swiper(container, {
      centeredSlides: true,
      initialSlide,
      loop: false,
      slidesPerView: 'auto',
      spaceBetween: 36,
      speed: 600,
      navigation: {
        nextEl,
        prevEl,
      },
      on: {
        init(instance) {
          recenterIfNeeded(instance, realSlideCount);
          scheduleNavSync(section);
        },
        slideChangeTransitionEnd(instance) {
          recenterIfNeeded(instance, realSlideCount);
          scheduleNavSync(section);
        },
      },
      breakpoints: {
        0: {
          spaceBetween: 12,
        },
        750: {
          spaceBetween: 36,
        },
      },
    });

    section._installationResizeHandler = () => scheduleNavSync(section);
    window.addEventListener('resize', section._installationResizeHandler);

    if (typeof ResizeObserver !== 'undefined') {
      section._installationResizeObserver = new ResizeObserver(() => {
        scheduleNavSync(section);
      });
      section._installationResizeObserver.observe(container);
    }

    scheduleNavSync(section);
    section.dataset.swiperReady = 'true';
    section.swiper = swiper;
  }

  function initInstallation(root = document) {
    root.querySelectorAll('[data-sunster-rvac-installation]').forEach(initInstallationSection);
  }

  document.addEventListener('DOMContentLoaded', () => initInstallation());
  document.addEventListener('shopify:section:load', (event) => initInstallation(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-sunster-rvac-installation]').forEach((section) => {
      if (section._installationNavFrame) {
        window.cancelAnimationFrame(section._installationNavFrame);
      }
      if (section._installationResizeHandler) {
        window.removeEventListener('resize', section._installationResizeHandler);
      }
      if (section._installationResizeObserver) {
        section._installationResizeObserver.disconnect();
      }
      if (section.swiper) {
        section.swiper.destroy(true, true);
      }
      delete section._installationNavFrame;
      delete section._installationResizeHandler;
      delete section._installationResizeObserver;
      delete section.swiper;
      delete section.dataset.swiperReady;
    });
  });
})();
